import reducer from "./reducers";

import * as locationDetailsOperations from "./operations";
import * as locationDetailsActions from "./actions";
import * as locationDetailsTypes from "./types";

export {
    locationDetailsOperations,
    locationDetailsActions,
    locationDetailsTypes
};

export default reducer;



// WEBPACK FOOTER //
// ./ducks/location-details/index.js